import { IconButton, styled } from '@mui/material';

import { formatUnixTimestampShortDate } from '@app-velocity/common';

import { TInvoiceDto } from '@app-velocity/av-api-v2';
import { DownloadIcon } from '@app-velocity/icons';
import { Typography } from '@app-velocity/ui';

const StyledSingleInvoice = styled('li')(({ theme }) => ({
  borderBottom: '1px solid #e3e3e3',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${theme.spacing(2)} 0`,
}));

const InvoiceTitle = styled(Typography)({
  fontSize: 14,
  fontWeight: 600,
});

const StyledIconButton = styled(IconButton)({
    svg: {
        fill: '#e3e3e3'
    }
})

export type SingleInvoiceProps = {
  invoice: TInvoiceDto;
};

export const SingleInvoice = ({ invoice }: SingleInvoiceProps) => {
  const { invoiceStartDate, invoiceUrl } = invoice;

  const viewInvoice = () => {
    window.open(invoiceUrl, '_blank');
  };

  return (
    <StyledSingleInvoice>
      {invoiceStartDate ? (
        <InvoiceTitle>{formatUnixTimestampShortDate(invoiceStartDate)}</InvoiceTitle>
      ) : null}
      {invoiceUrl ? (
        <StyledIconButton onClick={viewInvoice}>
          <DownloadIcon />
        </StyledIconButton>
      ) : null}
    </StyledSingleInvoice>
  );
};
